import { render, staticRenderFns } from "./fileTable.vue?vue&type=template&id=6e1fa993&"
import script from "./fileTable.vue?vue&type=script&lang=js&"
export * from "./fileTable.vue?vue&type=script&lang=js&"
import style0 from "./fileTable.vue?vue&type=style&index=0&id=6e1fa993&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports